import React from "react"
import MbpHead from "../components/head/MbpHead"
import NavBar from "../components/navigation/NavBar"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import nextI18NextConfig from "../next-i18next.config"
import fetchPageBySlug from "../fetch/FetchPageBySlug"
import parse from "html-react-parser"
import Footer from "../components/footer/Footer"
import {useTranslation} from "next-i18next"
import {getPageData} from "../pageData"

const PrivacyPolicy = (page: any) => {
	const {t} = useTranslation()
	const title = t("Datenschutz")
	const description = t("Datenschutzrichtlinie MyBikePlan")
	return (
		<>
			<MbpHead>
				<title>
					{title}
				</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta property="og:description"
					content={description}/>
			</MbpHead>
			<NavBar absolute={false}/>
			<main>
				<div className={"container"}>
					<div className={"row justify-content-center"}>
						<div className={"col-12 col-md-8"}>
							{Array.isArray(page?.page) && page?.page.length > 0 ? parse(page.page[0].content.rendered) : null}
						</div>
					</div>
				</div>
			</main>
			<Footer/>
		</>
	)
}

export async function getStaticProps({locale}) {
	return {
		props: {
			...(await getPageData(locale, [])),
			page: await fetchPageBySlug("privacy-policy", "de"),
			...(await serverSideTranslations(locale, ["common", "search", "filters"], nextI18NextConfig))
		}
	}
}

export default PrivacyPolicy
